import { Icon, type IconifyIcon } from '@iconify/react';
import { Box, type BoxProps } from '@mui/material';

// ----------------------------------------------------------------------

type Props = BoxProps & {
  icon: IconifyIcon | string;
};

export default function Iconify({ icon, sx, ...other }: Props) {
  return <Box component={Icon} icon={icon} sx={{ ...sx }} {...other} />;
}
